import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import FormGroup from "@mui/material/FormGroup";

import {setShippingErrors, setShippingInfo} from "../../../actions/paymentFunctions";
import LookAddressInput from "../../look/ui/lookAddressInput";
import LookInput from "../../look/ui/lookInput";
import WithInputValidations from "../../look/hocs/withInputValidations";
import {getShippingValidationErrors} from "../../look/grohe/groheCart/groheCartPayment/shippingValidation";


const AssignQuoteEditShipping = (props) => {

  const {isActive, shippingAddress, shippingErrors, setShippingInfo, setShippingErrors} = props;

  const shippingInputChange = (property, value) => {
    setShippingInfo(property, value);
  }

  return (
    <div className={"ass ass--new" + (isActive ? " ass--active" : "")}>
      <WithInputValidations>
        {(inputsValidated, updateInputValidations) => (
          <FormGroup>
            <div className="ass-fields">
              {Object.keys(shippingAddress).map(inputKey => {
                if (inputKey === "stateShort" || inputKey === "address2") {
                  return null
                }
                if (inputKey === "address1") {
                  return (
                    <LookAddressInput key={inputKey}
                                      property={inputKey}
                                      blockClassName="ass-field"
                                      inputClassName="ui-material-input"
                                      shouldSetCountry={true}
                                      updateInputValidations={updateInputValidations}
                                      inputsValidated={inputsValidated}
                                      inputValue={shippingAddress[inputKey] || ""}
                                      setInputValue={shippingInputChange}
                                      getValidationErrors={getShippingValidationErrors}
                                      errorsObject={shippingErrors}
                                      changeErrorsObject={setShippingErrors}
                                      isRequired={true} />
                  )
                }
                return (
                  <LookInput key={inputKey}
                             property={inputKey}
                             name={inputKey}
                             blockClassName="ass-field"
                             inputClassName="ui-material-input"
                             inputsValidated={inputsValidated}
                             inputValue={shippingAddress[inputKey] || ""}
                             setInputValue={shippingInputChange}
                             getValidationErrors={getShippingValidationErrors}
                             errorsObject={shippingErrors}
                             changeErrorsObject={setShippingErrors}
                             isRequired={false}/>
                )
              })}
            </div>
          </FormGroup>
        )}
      </WithInputValidations>
    </div>
  )
};

AssignQuoteEditShipping.propTypes = {
  isActive: PropTypes.bool.isRequired,
};

const mapStateToProps = (store) => {
  const {shippingAddress, shippingErrors} = store.paymentState;

  return {
    fabricatorData: store.fabricatorState,
    shippingAddress,
    shippingErrors,
  };
};

const mapDispatchToProps = {
  setShippingInfo,
  setShippingErrors,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignQuoteEditShipping)

